import ReactDOM from "react-dom"
import React, { Suspense, useEffect, useMemo, useRef } from "react"
import { Canvas, useFrame } from "@react-three/fiber"
import { Html } from "@react-three/drei"
import lerp from "lerp"
import Diamonds from "./diamonds/Diamonds"
import Plane from "./components/Plane"
import Content from "./components/Content"
import Header from "./components/Header"
import useContentStore from "./redux/stores/contentStore"
import "./styles.scss"

function Startup() {
  const ref = useRef()
  useFrame(() => (ref.current.material.opacity = lerp(ref.current.material.opacity, 0, 0.025)))
  return <Plane ref={ref} color="#0e0e0f" position={[0, 0, 200]} scale={[100, 100, 1]} />
}

function App() {
  const { content, current, change: setContent, setPage } = useContentStore((state) => state)
  const onScroll = useMemo(() => {
      return (e) => {
        if(content)
          content.top.current = e.currentTarget.scrollY;
      }
  }, [content]);
  const length = content ? content.paragraphs.length + 2 : 0;

  // Set first tab on load
  useEffect(() => {
    setPage("experiencesPage");
  }, []);

  // Update content on scroll
  useEffect(
    () => {
        onScroll({currentTarget: window});
        window.addEventListener("scroll", onScroll);

        return () => {
          window.removeEventListener("scroll", onScroll);
        }
    }, [content, onScroll])

  if(!content)
    return null;

  const divs = (() => {
      const intro = <div key="intro" id={"00"} style={{ height: `100vh` }} />;
      const outro = <div key="outro" id={"0" + (content.paragraphs.length + 1)} style={{ height: `100vh` }} />;
      const sections = content.paragraphs.map((paragraph, index) => {
          const height = paragraph.hugeText ? 100 : 100;
            return <div key={index} id={"0" + (index + 1)} style={{ height: `${height}vh` }} />;
      });
      return [intro, ...sections, outro];
      // return new Array(content.sections).fill().map((_, index) => (
      //   <div key={index} id={"0" + index} style={{ height: `${(content.pages / content.sections) * 100}vh` }} />
      // ))
  })();

  return (
    <>
      <Canvas linear dpr={[1, 2]} orthographic camera={{ zoom: content.zoom, position: [0, 0, 500] }} style={{position: "fixed",}}>
        <Suspense fallback={<Html center className="loading" children="Loading..." />}>
          <Content />
          <Diamonds />
          <Startup />
        </Suspense>
      </Canvas>
      <div className="scrollArea">
        {divs}
      </div>
      <Header />
     </>
  )
}

ReactDOM.render(<App />, document.getElementById("root"));
